import { http } from "../http/Http";
import { ProcessInstanceState } from "../models/ProcessInstanceState";
import { ServiceResponse } from "../models/ServiceResponse";

export class ProcessInstanceStateService {

    getProcessInstanceStates = async (): Promise<ServiceResponse<ProcessInstanceState[]>> => {
        const { data } = await http.get<ServiceResponse<ProcessInstanceState[]>>("ProcessInstanceState/GetAll");
        return data;
    };

}